import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestFoldersDelete = {
    path: "/folders/:id",
    method: RouteHttpVerb.DELETE
};
export { locationRestFoldersDelete };
